import "./style.scss"

import 'master';
import 'slick-carousel';

$(function() {
    

});
